import React, { createContext, useContext, useState } from 'react';

// Create AuthContext
const AuthContext = createContext();

// AuthProvider component
export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('access_token'));
  const [user, setUser] = useState(
    localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
  );
  const [permissions, setPermissions] = useState(
    JSON.parse(localStorage.getItem('permissions') ?? '[]')
  );

  const handleLogin = (data) => {
    localStorage.setItem('access_token', data.access_token);
    localStorage.setItem('user', JSON.stringify(data.user));
    localStorage.setItem('permissions', JSON.stringify(data.permissions ?? []));

    // Seeded here so the first authenticated request already carries a branch
    // header, rather than relying on the server default for one round trip.
    localStorage.setItem('branches', JSON.stringify(data.branches ?? []));
    localStorage.removeItem('branch_scope');

    if (data.active_branch_id) {
      localStorage.setItem('active_branch_id', data.active_branch_id);
    } else {
      localStorage.removeItem('active_branch_id');
    }

    setUser(data.user);
    setPermissions(data.permissions ?? []);
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    localStorage.removeItem('permissions');
    localStorage.removeItem('active_branch_id');
    localStorage.removeItem('branches');
    localStorage.removeItem('branch_scope');
    localStorage.removeItem('app_settings');
    setIsLoggedIn(false);
    setUser(null);
    setPermissions([]);
  };

  const can = (slug) => permissions.includes(slug);

  return (
    <AuthContext.Provider value={{ isLoggedIn, user, permissions, can, handleLogin, handleLogout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use auth context
export const useAuth = () => useContext(AuthContext);
